<template>
  <transition name="slide-y-reverse-transition">
    <v-card flat class="mt-2 order-log-card">
      <v-card-text class="text-xs-center order-log-card__header">
        <strong style="font-size: 18px">Order Log History</strong>
      </v-card-text>
      <v-flex class="text-xs-left order-log-card__table">
        <v-data-table
          :headers="headers"
          :items="order_detail.order_resend_order"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">
              {{ order_detail.order_resend_order.indexOf(props.item) + 1 }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.order_event_date +
                " " +
                props.item.order_event_time.split(".")[0]
              }}
            </td>
            <td class="text-xs-center">
              {{ props.item.order_event_user_name }}
            </td>
            <td class="text-xs-center">{{ props.item.order_event_status }}</td>
          </template>
          <template slot="no-data">
            <center>No order log history yet.</center>
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </transition>
</template>

<script>
export default {
  props: ["order_detail"],
  data() {
    return {
      headers: [
        { text: "No.", align: "center", sortable: false, value: "num" },
        { text: "Date/Time", value: "date", sortable: false, align: "center" },
        { text: "User", value: "user", sortable: false, align: "center" },
        { text: "Action", value: "user", sortable: false, align: "center" },
      ],
    };
  },
};
</script>

<style scoped>
.order-log-card {
  background: rgba(255, 255, 255, 0.68) !important;
  border: 1px solid rgba(255, 255, 255, 0.82) !important;
  border-radius: 16px !important;
  box-shadow: 0 18px 52px rgba(27, 39, 51, 0.1) !important;
  overflow: hidden !important;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.order-log-card__header {
  background: transparent;
}

.order-log-card__table {
  max-height: 180px;
  overflow-y: auto;
}

.order-log-card__table >>> .v-table,
.order-log-card__table >>> .v-table__overflow {
  background: transparent !important;
}
</style>
